import React from 'react';

import axiosInstance from '../actions/AxiosInstance';
import api from '../actions/EndPoints';
import connectWithUserStore from '../reducers/connectWithUserStore';

import CardContainer from './CardContainer';
import Loading from './Loading';
import SuccessProbabilityBar from '../components/SuccessProbabilityBar';
import { anonymousUserData } from '../components/shared/Content';
import RasBanner from '../components/shared/RasBanner';
import { Box } from '@mui/material';

const NextStepsContainerView = connectWithUserStore(({ state, dispatch, applicationConfig }) => {
    const { age, clientType, confidenceScoreResult, isAuthenticated, showMeter, assetAmount, upperLimit, lowerLimit } = state || anonymousUserData;
    const [showLoader, setShowLoader] = React.useState(true);
    console.log('state', state);
    console.log('age', age, 'clientType', clientType, 'confidenceScoreResult', confidenceScoreResult);

    React.useEffect(() => {
        let isLoaded = false;
        const  { validNS } = JSON.parse(localStorage.getItem('RIC')) || {};

        console.log('validNS', validNS);
        if (!isLoaded) {
            if (validNS) {
                console.log('validNS', validNS);
                setTimeout(() => {
                    localStorage.setItem('RIC', JSON.stringify({validNS: false}));
                }, 3000)
            }
            if (JSON.parse(localStorage.getItem('RIC')) && !validNS) {
                console.log('validNS', validNS);
                localStorage.removeItem('RIC');
            }
            if (!JSON.parse(localStorage.getItem('RIC'))) {
                console.log('nothing')
            }
        }

        return () => {
            isLoaded = true;
        };
    }, []);

    React.useEffect(() => {
        let isCancelled = false;
        const loadUrls = async () => {
            if (!isCancelled) {
                try {
                    const scoreData = await axiosInstance.get(api.getScoreAPI, {
                        headers: {
                            apiKey: applicationConfig.apiKey,
                        }
                    });
                    if (scoreData) {
                        const { data } = scoreData;
                        console.log('score success', data, data.age);
                        dispatch({
                            type: 'SCORE_DATA',
                            age: data.age,
                            clientType: data.clientType,
                            confidenceScoreResult: data.confidenceScoreResult,
                            lowerLimit: data.confidenceZoneLower,
                            upperLimit: data.confidenceZoneUpper,
                            assetAmount: data.retirementAssetAmount,
                            showMeter: true
                        });
                        setShowLoader(false);
                    }
                } catch (error) {
                    console.log('score Error', error);
                    dispatch({
                        type: 'SCORE_DATA',
                        age: 40,
                        clientType: 'Guest',
                        confidenceScoreResult: 69,
                        lowerLimit: 70,
                        upperLimit: 95
                    });
                    setShowLoader(false);
                }
            }
        };

        if (isAuthenticated) {
            loadUrls();
        }

        return () => {
            isCancelled = true;
        };
    }, [dispatch, isAuthenticated, applicationConfig.apiKey]);

    return (
        <Box>
        {isAuthenticated && showLoader ? (<Loading headerText="Preparing Next Steps..."/>) :
            (
                <div>
                    <SuccessProbabilityBar
                        age={age}
                        confidenceScoreResult={confidenceScoreResult}
                        isAuthenticated={isAuthenticated}
                        showMeter={showMeter}
                        lowerLimit={lowerLimit}
                        upperLimit={upperLimit}
                    />
                    <CardContainer
                        clientType={clientType}
                        confidenceScoreResult={confidenceScoreResult}
                        assetAmount={assetAmount}
                    />
                    <RasBanner />
                </div>
            )}
        </Box>
    );
});

export default function NextStepsContainer({ applicationConfig }) {
    return <NextStepsContainerView applicationConfig={applicationConfig} />;
}
